import http from './HttpService';
import { API_BASE_AUDIENCE } from '../../constants/index';
import { IActiveInactiveListContact, ISearchListContacts } from 'modules/Campaigns/Audience/interface';
import { getQueryListId } from 'utils';
import axios from 'axios';

export async function searchContactsService(campaignId: number, searchValue: string, isAsset: boolean, offset: number, limit: number) {
  if (isAsset) {
    return await http.get(`${API_BASE_AUDIENCE}get_asset_contacts/${campaignId}/?contact_name=${searchValue}&offset=${offset}&limit=${limit}`);
  } else {
    return await http.get(`${API_BASE_AUDIENCE}get_campaign_contacts/${campaignId}/?contact_name=${searchValue}`);
  }
}

export async function getListForAssetService(assetId: number) {
  return await http.get(`${API_BASE_AUDIENCE}get_asset_lists/${assetId}/?publish_page=1`);
}

export async function getContactsForAssetService(
  assetId: number,
  offset: number,
  limit: number,
  searchTerm = '',
  publishPage: boolean = false,
  sort_by: string,
  sort_type: string,
  active_count?: boolean,
) {
  let url = `${API_BASE_AUDIENCE}get_asset_contacts/${assetId}/?limit=${limit}&offset=${offset}`;
  if (searchTerm) url += `&contact_name=${searchTerm}`;
  if (publishPage) url += `&publish_page=1`;
  if (sort_by.length > 0) url += `&sort_by=${sort_by}`;
  if (sort_type.length > 0) url += `&sort_type=${sort_type}`;
  if (active_count) url += `&active_count=${active_count}`;
  return await http.get(url);
}
let cancelTokenPersonDetails: any;
export async function getContactDetailsService(contact_id: string) {
  //Check if there are any previous pending requests
  if (typeof cancelTokenPersonDetails != typeof undefined) {
    cancelTokenPersonDetails && cancelTokenPersonDetails.cancel('Operation canceled due to new request.');
  }

  //Save the cancel token for the current request
  cancelTokenPersonDetails = axios.CancelToken.source();

  return await http.get(
    `${API_BASE_AUDIENCE}get_person_details/${contact_id}/`,
    { cancelToken: cancelTokenPersonDetails.token }, //Pass the cancel token to the current request
  );
}
let cancelTokenDashboard: any;
export async function getContactDashboardService(contact_id: string) {
  //Check if there are any previous pending requests
  if (typeof cancelTokenDashboard != typeof undefined) {
    cancelTokenDashboard && cancelTokenDashboard.cancel('Operation canceled due to new request.');
  }

  //Save the cancel token for the current request
  cancelTokenDashboard = axios.CancelToken.source();
  return await http.get(
    `${API_BASE_AUDIENCE}dashboard_tab/?person_id=${contact_id}`,
    { cancelToken: cancelTokenDashboard.token }, //Pass the cancel token to the current request
  );
}
let cancelTokenSubscription: any;
export async function getContactSubscriptionsService(contact_id: string) {
  //Check if there are any previous pending requests
  if (typeof cancelTokenSubscription != typeof undefined) {
    cancelTokenSubscription && cancelTokenSubscription.cancel('Operation canceled due to new request.');
  }

  //Save the cancel token for the current request
  cancelTokenSubscription = axios.CancelToken.source();
  return await http.get(
    `${API_BASE_AUDIENCE}subscriptions_tab/?person_id=${contact_id}`,
    { cancelToken: cancelTokenSubscription.token }, //Pass the cancel token to the current request
  );
}
let cancelTokenEngagement: any;
export async function getContactEngagementService(contact_id: string) {
  //Check if there are any previous pending requests
  if (typeof cancelTokenEngagement != typeof undefined) {
    cancelTokenEngagement && cancelTokenEngagement.cancel('Operation canceled due to new request.');
  }

  //Save the cancel token for the current request
  cancelTokenEngagement = axios.CancelToken.source();
  const payload = new FormData();
  payload.append('contact_id', contact_id);
  return await http.post(
    `${API_BASE_AUDIENCE}engagement_tab/`,
    payload,
    { cancelToken: cancelTokenEngagement.token }, //Pass the cancel token to the current request
  );
}
let cancelTokenSimilar: any;
export async function getContactSimilarService(contact_id: string) {
  //Check if there are any previous pending requests
  if (typeof cancelTokenSimilar != typeof undefined) {
    cancelTokenSimilar && cancelTokenSimilar.cancel('Operation canceled due to new request.');
  }

  //Save the cancel token for the current request
  cancelTokenSimilar = axios.CancelToken.source();
  return await http.get(
    `${API_BASE_AUDIENCE}similar_tab/?contact_id=${contact_id}`,
    { cancelToken: cancelTokenSimilar.token }, //Pass the cancel token to the current request
  );
}

export async function linkAudienceWithCampaignService(campaignId: number, listIds: number[], contactIds: number[]) {
  const payload = new FormData();
  payload.append('campaign_id', campaignId.toString());
  for (let item of contactIds) {
    payload.append('contact_ids', item.toString());
  }
  for (let item of listIds) {
    payload.append('list_ids', item.toString());
  }
  return await http.post(API_BASE_AUDIENCE + 'add_campaign_audience/', payload);
}

export async function linkAudienceWithAssetService(
  assetId: number,
  listIds: number[],
  contactIds: number[],
  unlink: boolean,
  selectAllLists?: boolean,
  selectAllContacts?: boolean,
  excludeContacts?: number[],
  excludeLists?: number[],
  searchTerm?: string,
) {
  const payload = new FormData();
  payload.append('asset_id', assetId.toString());
  payload.append('unlink', unlink.toString());
  if (unlink) {
    if (listIds?.length) {
      for (let item of listIds) {
        payload.append('list_ids', item.toString());
      }
    }
    if (contactIds?.length && !selectAllContacts) {
      for (let item of contactIds) {
        payload.append('contact_ids', item.toString());
      }
    }
  } else {
    for (let item of listIds) {
      payload.append('list_ids', item.toString());
    }
    for (let item of contactIds) {
      payload.append('contact_ids', item.toString());
    }
  }
  if (selectAllLists) {
    payload.append('select_all_lists', selectAllLists.toString());
    if (excludeLists?.length) {
      for (let item of excludeLists) {
        payload.append('exclude_lists', item.toString());
      }
    }
  }
  if (selectAllContacts) {
    payload.append('select_all_contacts', selectAllContacts.toString());
    if (excludeContacts?.length) {
      for (let item of excludeContacts) {
        payload.append('exclude_contacts', item.toString());
      }
    }
  }
  if (searchTerm) {
    payload.append('search_term', searchTerm.toString());
  }
  return await http.post(API_BASE_AUDIENCE + 'add_asset_audience/', payload);
}

let cancelTokenRecommendedLists: any;
export async function getRecommendedListsService(offset: number, limit: number) {
  const payload = new FormData();
  payload.append('limit', limit?.toString());
  payload.append('offset', offset?.toString());
  if (typeof cancelTokenRecommendedLists != typeof undefined) {
    cancelTokenRecommendedLists && cancelTokenRecommendedLists.cancel('Operation canceled due to new request.');
  }
  //Save the cancel token for the current request
  cancelTokenRecommendedLists = axios.CancelToken.source();

  return await http.post(`${API_BASE_AUDIENCE}get_recommended_list_v2/`, payload, {
    cancelToken: cancelTokenRecommendedLists.token, //Pass the cancel token to the current request
  });
}

let cancelTokenRecommendedPeople: any;
export async function getRecommendedPeopleService(offset: number, limit: number, selectAllFlag?: boolean, listId?: string, excludedIds?: string[]) {
  const payload = new FormData();
  payload.append('offset', offset?.toString());
  payload.append('limit', limit?.toString());
  if (selectAllFlag) {
    payload.append('select_all_flag', true.toString());
    if (listId && parseInt(listId) > 0) payload.append('list_id', listId);
    if (excludedIds && excludedIds.length > 0) payload.append('excluded_ids', excludedIds.join(','));
  }

  //Check if there are any previous pending requests
  if (typeof cancelTokenRecommendedPeople != typeof undefined) {
    cancelTokenRecommendedPeople && cancelTokenRecommendedPeople.cancel('Operation canceled due to new request.');
  }
  //Save the cancel token for the current request
  cancelTokenRecommendedPeople = axios.CancelToken.source();

  return await http.post(`${API_BASE_AUDIENCE}get_recommended_contacts_v2/`, payload, {
    cancelToken: cancelTokenRecommendedPeople.token, //Pass the cancel token to the current request
  });
}

let cancelTokenSearchPeople: any;
export async function searchPeopleService(
  offset: number,
  limit: number,
  searchTerm: string,
  isKeywords?: boolean,
  selectAllFlag?: boolean,
  listId?: string,
  excludedIds?: string[],
) {
  const payload = new FormData();
  if (searchTerm.length > 0) {
    if (isKeywords) payload.append('keywords', searchTerm);
    else payload.append('contact_name', searchTerm);
  }
  payload.append('limit', limit?.toString());
  payload.append('offset', offset.toString());
  if (selectAllFlag) {
    payload.append('select_all_flag', true.toString());
    if (listId && parseInt(listId) > 0) payload.append('list_id', listId);
    if (excludedIds && excludedIds.length > 0) payload.append('excluded_ids', excludedIds.join(','));
  }
  //Check if there are any previous pending requests
  if (typeof cancelTokenSearchPeople != typeof undefined) {
    cancelTokenSearchPeople && cancelTokenSearchPeople.cancel('Operation canceled due to new request.');
  }
  //Save the cancel token for the current request
  cancelTokenSearchPeople = axios.CancelToken.source();

  return await http.post(`${API_BASE_AUDIENCE}get_recommended_contacts_v2/`, payload, {
    cancelToken: cancelTokenSearchPeople.token, //Pass the cancel token to the current request
  });
}

let cancelTokenDynamicAudienceSearch: any;
export async function dynamicAudienceSearchService(
  offset: number,
  limit: number,
  searchTerm: string,
  dynamicKeywords: string,
  selectAllFlag?: boolean,
  listId?: string,
  excludedIds?: string[],
) {
  const payload = new FormData();
  if (dynamicKeywords.length > 0) payload.append('keywords', dynamicKeywords);
  if (searchTerm.length > 0) payload.append('contact_name', searchTerm);
  payload.append('offset', offset?.toString());
  payload.append('limit', limit?.toString());
  if (selectAllFlag) {
    payload.append('select_all_flag', true.toString());
    if (listId && parseInt(listId) > 0) payload.append('list_id', listId);
    if (excludedIds && excludedIds.length > 0) payload.append('excluded_ids', excludedIds.join(','));
  }
  //Check if there are any previous pending requests
  if (typeof cancelTokenDynamicAudienceSearch != typeof undefined) {
    cancelTokenDynamicAudienceSearch && cancelTokenDynamicAudienceSearch.cancel('Operation canceled due to new request.');
  }
  //Save the cancel token for the current request
  cancelTokenDynamicAudienceSearch = axios.CancelToken.source();

  return await http.post(`${API_BASE_AUDIENCE}get_recommended_contacts_v2/`, payload, {
    cancelToken: cancelTokenDynamicAudienceSearch.token, //Pass the cancel token to the current request
  });
}

let cancelTokenRecommendedContactsExport: any;
export async function recommendedPeopleExportService(searchTerm?: string, dynamicKeywords?: string) {
  const payload = new FormData();
  if (dynamicKeywords) payload.append('keywords', dynamicKeywords?.toString());
  if (searchTerm) payload.append('contact_name', searchTerm?.toString());
  // if (selectAllFlag) {
  //   payload.append("select_all_flag", true.toString());
  //   if (listId && parseInt(listId) > 0) payload.append("list_id", listId);
  //   if (excludedIds && excludedIds.length > 0) payload.append("excluded_ids", excludedIds.join(","));
  // }

  payload.append('export', 'true');

  //Check if there are any previous pending requests
  if (typeof cancelTokenRecommendedContactsExport != typeof undefined) {
    cancelTokenRecommendedContactsExport && cancelTokenRecommendedContactsExport.cancel('Operation canceled due to new request.');
  }
  //Save the cancel token for the current request
  cancelTokenRecommendedContactsExport = axios.CancelToken.source();

  return await http.post(`${API_BASE_AUDIENCE}get_recommended_contacts_v2/`, payload, {
    cancelToken: cancelTokenRecommendedContactsExport.token, //Pass the cancel token to the current request
  });
}

export async function searchListService(
  offset: number,
  limit: number,
  searchTerm: string,
  isKeywords?: boolean,
  selectAllFlag?: boolean,
  listId?: string,
  excludedIds?: string[],
) {
  const payload = new FormData();
  if (searchTerm.length > 0) {
    if (isKeywords) {
      payload.append('keywords', searchTerm);
      // payload.append("list_name", searchTerm);
    } else payload.append('list_name', searchTerm);
  }
  payload.append('limit', limit?.toString());
  payload.append('offset', offset?.toString());
  return await http.post(`${API_BASE_AUDIENCE}get_recommended_list_v2/`, payload);
}

let cancelTokenOverview: any;
export async function getAudienceListsService(params: any) {
  //Check if there are any previous pending requests
  if (typeof cancelTokenOverview != typeof undefined) {
    cancelTokenOverview && cancelTokenOverview.cancel('Operation canceled due to new request.');
  }
  //Save the cancel token for the current request
  cancelTokenOverview = axios.CancelToken.source();

  return await http.get(`${API_BASE_AUDIENCE}mailing_lists/?${params}`, {
    cancelToken: cancelTokenOverview.token,
  });
}
export async function getAudienceListsNamesOnlyService() {
  return await http.get(`${API_BASE_AUDIENCE}mailing_lists/?list_only=${true}`);
}
export async function exportListDetailsService(queryParams: any, listId?: number) {
  const { filter_by_organization, filter_by_designation, personality_type, status, searchTermListContacts, searchTermPeople, emailId, uuid } =
    queryParams;

  const payload = new FormData();

  payload.append('export', true.toString());

  if (filter_by_organization !== undefined && filter_by_organization.length > 0) {
    for (let organization of filter_by_organization) {
      payload.append('filter_by_organization', organization);
    }
  }

  if (filter_by_designation !== undefined && filter_by_designation.length > 0) {
    for (let designation of filter_by_designation) {
      payload.append('filter_by_designation', designation);
    }
  }

  if (personality_type !== undefined && personality_type.length > 0) {
    payload.append('personality_type', personality_type.join(','));
  }

  if (status !== undefined && status.length > 0) {
    payload.append('status', status.join(','));
  }

  if (searchTermListContacts !== undefined && searchTermListContacts !== '') {
    payload.append('search_by_name', searchTermListContacts);
  }

  if (searchTermPeople !== undefined && searchTermPeople !== '') {
    payload.append('search_by_name', searchTermPeople);
  }

  if (emailId) {
    payload.append('email_id', emailId);
  }

  if (uuid) {
    payload.append('uuid', uuid);
  }

  if (listId) {
    return await http.post(`${API_BASE_AUDIENCE}list_contacts/${listId}/`, payload);
  } else {
    return await http.post(`${API_BASE_AUDIENCE}get_people/`, payload);
  }
}

export async function cloneListService(listId: string) {
  const payload = new FormData();
  payload.append('original_list_id', listId);
  payload.append('clone_list', 'true');
  return await http.post(`${API_BASE_AUDIENCE}create_list/`, payload);
}

export async function createNewListService(
  listName: string,
  contactIds: any,
  listId?: string,
  selectAllFlag?: boolean,
  excludedIds?: any,
  originalListId?: string,
  fromPeopleTab?: boolean,
  selectedOrganization?: string[],
  selectedDesignation?: string[],
  selectedPersonality?: string[],
  selectedStatus?: string[],
  searchTerm?: string,
  fromGloabalListing?: boolean,
) {
  const payload = new FormData();
  if (listId && listId !== '') {
    payload.append('list_id', listId);
  }
  // add contact ids in payload. Previous:if (contactIds?.length > 0 && !selectAllFlag)
  if (contactIds?.length > 0) {
    for (let item of contactIds) {
      payload.append('contact_ids', item.toString());
    }
  }
  if (listName.trim() !== '') {
    payload.append('list_name', listName);
  }
  if (selectAllFlag) {
    payload.append('select_all', selectAllFlag.toString());
  }
  if (excludedIds?.length > 0) {
    for (let item of excludedIds) {
      payload.append('excluded_contacts_list', item.toString());
    }
  }
  if (!fromGloabalListing) {
    originalListId && payload.append('original_list_id', originalListId.toString());
  } else {
    originalListId && payload.append('exclude_list_id', originalListId.toString());
  }
  if (fromPeopleTab) {
    payload.append('from_people_tab', fromPeopleTab.toString());
  }
  if (searchTerm !== undefined && searchTerm !== '') {
    payload.append('search_by_name', searchTerm);
  }
  if (selectAllFlag) {
    if (selectedOrganization !== undefined && selectedOrganization.length > 0) {
      for (let organization of selectedOrganization) {
        payload.append('filter_by_organization', organization);
      }
    }

    if (selectedDesignation !== undefined && selectedDesignation.length > 0) {
      for (let designation of selectedDesignation) {
        payload.append('filter_by_designation', designation);
      }
    }

    if (selectedPersonality !== undefined && selectedPersonality.length > 0) {
      payload.append('personality_type', selectedPersonality.join(','));
    }

    if (selectedStatus !== undefined && selectedStatus.length > 0) {
      payload.append('status', selectedStatus.join(','));
    }
  }
  return await http.post(`${API_BASE_AUDIENCE}create_list/`, payload);
}

export async function editListNameService(listId: string, newName: string) {
  const payload = new FormData();
  payload.append('list_name', newName);
  return await http.post(`${API_BASE_AUDIENCE}edit_list/${listId}/`, payload);
}
let cancelTokenAllPeople: any;
export async function getAudienceAllPeopleListService(
  limit: number,
  offset: number,
  tabState: string,
  searchTerm: string,
  filter_by_organization: string[],
  filter_by_designation: string[],
  personality_type: string[],
  filter_by_status: string[],
  sort_by: string,
  sort_type: string,
  email_id: string,
  uuid: string,
) {
  //Check if there are any previous pending requests
  if (typeof cancelTokenAllPeople != typeof undefined) {
    cancelTokenAllPeople && cancelTokenAllPeople.cancel('Operation canceled due to new request.');
  }

  const list_id = new URLSearchParams(window.location.search).get('list_id');

  //Save the cancel token for the current request
  cancelTokenAllPeople = axios.CancelToken.source();

  const payload = new FormData();

  payload.append('profiled', '-1');
  payload.append('limit', limit.toString());
  payload.append('offset', offset.toString());

  if (filter_by_organization !== undefined && filter_by_organization.length > 0) {
    for (let organization of filter_by_organization) {
      payload.append('filter_by_organization', organization);
    }
  }

  if (filter_by_designation !== undefined && filter_by_designation.length > 0) {
    for (let designation of filter_by_designation) {
      payload.append('filter_by_designation', designation);
    }
  }

  if (personality_type !== undefined && personality_type.length > 0) {
    payload.append('personality_type', personality_type.join(','));
  }

  if (filter_by_status !== undefined && filter_by_status.length > 0) {
    payload.append('status', filter_by_status.join(','));
  }

  if (searchTerm !== undefined && searchTerm !== '') {
    payload.append('search_by_name', searchTerm);
  }

  if (sort_by.length > 0) {
    payload.append('sort_by', sort_by);
  }

  if (sort_type.length > 0) {
    payload.append('sort_type', sort_type);
  }

  if (email_id.length > 0) {
    payload.append('email_id', email_id);
  }
  if (uuid.length > 0) {
    payload.append('uuid', uuid);
  }

  if (list_id && list_id !== '') {
    payload.append('list_id', list_id);
  }
  // console.log("emailId", list_id);
  return await http.post(
    `${API_BASE_AUDIENCE}get_people/`,
    payload,
    { cancelToken: cancelTokenAllPeople.token }, //Pass the cancel token to the current request
  );
}

let cancelTokenProfiled: any;
export async function getListofProfiledPeopleService(
  limit: number,
  offset: number,
  tabState: string,
  searchTerm: string,
  filter_by_organization: string[],
  filter_by_designation: string[],
  personality_type: string[],
  filter_by_status: string[],
) {
  //Check if there are any previous pending requests
  if (typeof cancelTokenProfiled != typeof undefined) {
    cancelTokenProfiled && cancelTokenProfiled.cancel('Operation canceled due to new request.');
  }

  //Save the cancel token for the current request
  cancelTokenProfiled = axios.CancelToken.source();

  const payload = new FormData();

  payload.append('profiled', '-1');
  payload.append('limit', limit.toString());
  payload.append('offset', offset.toString());

  if (filter_by_organization !== undefined && filter_by_organization.length > 0) {
    for (let organization of filter_by_organization) {
      payload.append('filter_by_organization', organization);
    }
  }

  if (filter_by_designation !== undefined && filter_by_designation.length > 0) {
    for (let designation of filter_by_designation) {
      payload.append('filter_by_designation', designation);
    }
  }

  if (personality_type !== undefined && personality_type.length > 0) {
    payload.append('personality_type', personality_type.join(','));
  }

  if (filter_by_status !== undefined && filter_by_status.length > 0) {
    payload.append('status', filter_by_status.join(','));
  }

  if (searchTerm !== undefined && searchTerm !== '') {
    payload.append('search_by_name', searchTerm);
  }
  return await http.post(
    `${API_BASE_AUDIENCE}get_people/`,
    payload,
    { cancelToken: cancelTokenProfiled.token }, //Pass the cancel token to the current request
  );
}

export async function getAudienceListDetailsService(listId: string, cancelToken?: any) {
  return await http.get(`${API_BASE_AUDIENCE}list_details/${listId}/`, {
    ...(cancelToken ? { cancelToken } : {}),
  });
}

let cancelTokenGetAudienceListDetailsContactsService: any;
export async function getAudienceListDetailsContactsService(list_id: string, params: any) {
  const { offset, limit, filter_by_organization, filter_by_designation, personality_type, status, search_term, sort_by, sort_type } = params;

  if (typeof cancelTokenGetAudienceListDetailsContactsService != typeof undefined) {
    cancelTokenGetAudienceListDetailsContactsService &&
      cancelTokenGetAudienceListDetailsContactsService.cancel('Operation canceled due to new request.');
  }

  //Save the cancel token for the current request
  cancelTokenGetAudienceListDetailsContactsService = axios.CancelToken.source();

  const payload = new FormData();

  payload.append('limit', limit.toString());
  payload.append('offset', offset.toString());

  if (filter_by_organization !== undefined && filter_by_organization.length > 0) {
    for (let organization of filter_by_organization) {
      payload.append('filter_by_organization', organization);
    }
  }

  if (filter_by_designation !== undefined && filter_by_designation.length > 0) {
    for (let designation of filter_by_designation) {
      payload.append('filter_by_designation', designation);
    }
  }

  if (personality_type !== undefined && personality_type.length > 0) {
    payload.append('personality_type', personality_type.join(','));
  }

  if (status !== undefined && status.length > 0) {
    payload.append('status', status.join(','));
  }

  if (search_term && search_term.length > 0) {
    payload.append('search_by_name', search_term);
  }

  if (sort_by.length > 0) {
    payload.append('sort_by', sort_by);
  }

  if (sort_type.length > 0) {
    payload.append('sort_type', sort_type);
  }

  return await http.post(`${API_BASE_AUDIENCE}list_contacts/${list_id}/`, payload, {
    // ...(cancelToken ? { cancelToken } : {}),
    cancelToken: cancelTokenGetAudienceListDetailsContactsService.token,
  });
}

export async function deleteAudienceListContactsService(
  list_id: string,
  contactIds: any,
  deleteAll: boolean,
  unselectedIds: any,
  tab?: string,
  selectedOrganization?: string[],
  selectedDesignation?: string[],
  selectedPersonalityType?: string[],
  selectedStatus?: string[],
  searchTermList?: string,
) {
  const payload = new FormData();
  if (!deleteAll) {
    let contacts_ids = contactIds.join(',');
    payload.append('contact_ids', contacts_ids);
  }
  if (unselectedIds.length > 0) {
    let unselected_ids = unselectedIds.join(',');
    payload.append('exclude_contacts_delete', unselected_ids);
  }
  // if (tab) {
  //   const profiledTab = tab === "profiled" ? "1" : "0";
  //   payload.append("profiled", profiledTab);
  // }

  payload.append('delete_all', deleteAll.toString());
  if (deleteAll) {
    if (selectedOrganization !== undefined && selectedOrganization.length > 0) {
      for (let organization of selectedOrganization) {
        payload.append('filter_by_organization', organization);
      }
    }

    if (selectedDesignation !== undefined && selectedDesignation.length > 0) {
      for (let designation of selectedDesignation) {
        payload.append('filter_by_designation', designation);
      }
    }

    if (selectedPersonalityType !== undefined && selectedPersonalityType.length > 0) {
      payload.append('personality_type', selectedPersonalityType.join(','));
    }

    if (selectedStatus !== undefined && selectedStatus.length > 0) {
      payload.append('status', selectedStatus.join(','));
    }
    if (searchTermList !== undefined && searchTermList.length > 0) {
      payload.append('search_by_name', searchTermList);
    }
  }
  return await http.post(`${API_BASE_AUDIENCE}delete_list_contacts/${list_id}/`, payload);
}

export async function createNewContactAudienceService(form: any) {
  const payload = new FormData();
  payload.append('email', form.email);
  payload.append('first_name', form.fName);
  payload.append('last_name', form.lName);
  payload.append('job_title', form.role);
  payload.append('company_name', form.company);
  payload.append('company_website', form.domain);
  if (form.listId) payload.append('list_id', form.listId);
  return await http.post(`${API_BASE_AUDIENCE}create_contact/`, payload);
}

export async function updateContactService(form: any, contactId: string) {
  const payload = new FormData();
  payload.append('contact_id', contactId);
  payload.append('first_name', form.fName);
  payload.append('last_name', form.lName);
  payload.append('email', form.email);
  payload.append('phone_number', form.pNumber);
  payload.append('job_title', form.role);
  payload.append('company_name', form.company);
  payload.append('company_website', form.domain);

  return await http.post(`${API_BASE_AUDIENCE}edit_contact/`, payload);
}

export async function deleteListService(listId: string) {
  const payload = new FormData();
  return await http.post(`${API_BASE_AUDIENCE}delete_list/${listId}/`, payload);
}
export async function deletePeopleinAudience(
  contacts: any,
  deleteAll: boolean,
  unselectedIds: any,
  tab?: string,
  isSearch?: string,
  selectedOrganization?: string[],
  selectedDesignation?: string[],
  selectedPersonalityType?: string[],
  selectedStatus?: string[],
  listId?: string,
  excludeListId?: string,
) {
  const payload = new FormData();
  // for (let id of contacts) {
  //   payload.append("contact_ids", id);
  // }
  if (!deleteAll) {
    let contacts_ids = contacts.join(',');
    payload.append('contact_ids', contacts_ids);
  }
  if (unselectedIds.length > 0) {
    let unselected_ids = unselectedIds.join(',');
    payload.append('exclude_contacts_delete', unselected_ids);
  }
  payload.append('delete_all', deleteAll.toString());
  if (tab) {
    const profiledTab = tab === 'all' ? '-1' : tab === 'profiled' ? '1' : '0';
    payload.append('profiled', profiledTab);
  }
  if (isSearch && isSearch.length > 0) {
    payload.append('search_by_name', isSearch);
  }
  if (deleteAll) {
    if (selectedOrganization !== undefined && selectedOrganization.length > 0) {
      for (let organization of selectedOrganization) {
        payload.append('filter_by_organization', organization);
      }
    }

    if (selectedDesignation !== undefined && selectedDesignation.length > 0) {
      for (let designation of selectedDesignation) {
        payload.append('filter_by_designation', designation);
      }
    }

    if (selectedPersonalityType !== undefined && selectedPersonalityType.length > 0) {
      payload.append('personality_type', selectedPersonalityType.join(','));
    }

    if (selectedStatus !== undefined && selectedStatus.length > 0) {
      payload.append('status', selectedStatus.join(','));
    }
  }

  if (listId) {
    payload.append('list_id', listId);
  }

  if (excludeListId) {
    payload.append('exclude_list', excludeListId);
  }

  return await http.post(`${API_BASE_AUDIENCE}delete_contact/`, payload);
}

export async function deleteCampaignAudienceService(listIds: any, contactIds: any, campaignId: string) {
  const payload = new FormData();
  for (let id of listIds) {
    payload.append('list_ids', id);
  }
  for (let id of contactIds) {
    payload.append('contact_ids', id);
  }
  payload.append('campaign_id', campaignId);
  return await http.post(`${API_BASE_AUDIENCE}delete_campaign_audience/`, payload);
}

export async function deleteAssetAudienceService(listIds: any, contactIds: any, assetId: string) {
  const payload = new FormData();
  for (let id of listIds) {
    payload.append('list_ids', id);
  }
  for (let id of contactIds) {
    payload.append('contact_ids', id);
  }
  payload.append('asset_id', assetId);
  return await http.post(`${API_BASE_AUDIENCE}delete_asset_audience/`, payload);
}

export async function addListContactService(
  listId: string,
  contactId: string,
  listName?: string,
  selectAllFlag?: boolean,
  excludedIds?: any,
  peopleTab?: string,
) {
  const payload = new FormData();
  if (listId !== '') {
    payload.append('list_id', listId);
  }
  if (contactId.length > 0) {
    payload.append('contact_id', contactId);
  }
  if (listName) {
    payload.append('list_name', listName);
  }
  if (selectAllFlag) {
    payload.append('select_all', selectAllFlag.toString());
  }
  if (peopleTab) {
    payload.append('Profiled', peopleTab ? '1' : '2');
  }
  if (excludedIds?.length > 0) {
    payload.append('excluded_contacts_list', excludedIds.join(','));
  }
  return await http.post(`${API_BASE_AUDIENCE}add_list_contact/`, payload);
}
export async function importListService(listName: string, mappings: string, selectedFile: File) {
  const payload = new FormData();
  payload.append('list_name', listName);
  payload.append('mappings', mappings);
  payload.append('contacts_file', selectedFile);
  let list_id = getQueryListId();
  if (list_id) payload.append('list_id', list_id.toString());
  return await http.post(`${API_BASE_AUDIENCE}import_new_list/`, payload);
}

export async function importListProgressService(list_id: number) {
  return await http.get(`${API_BASE_AUDIENCE}import_new_list_progress/${list_id}/`);
}
let cancelTokenSearchListContacts: any;
export async function searchListContactService(searchTerm: string, params?: ISearchListContacts) {
  //Check if there are any previous pending requests
  if (typeof cancelTokenSearchListContacts != typeof undefined) {
    cancelTokenSearchListContacts && cancelTokenSearchListContacts.cancel('Operation canceled due to new request.');
  }

  //Save the cancel token for the current request
  cancelTokenSearchListContacts = axios.CancelToken.source();

  let url = `${API_BASE_AUDIENCE}search_list_contact/?name=${searchTerm}&limit=10`;
  if (params) {
    const { selectAllFlag, listId, excludedIds } = params;
    if (selectAllFlag) {
      url += `&select_all_flag=${selectAllFlag}`;
    }
    if (listId && listId.length > 0) {
      url += `&list_id=${listId}`;
    }
    if (excludedIds && excludedIds.length > 0) {
      url += `&excluded_ids=${excludedIds.join(',')}`;
    }
  }
  return await http.get(
    url,
    { cancelToken: cancelTokenSearchListContacts.token }, //Pass the cancel token to the current request
  );
}

export async function getPublishRecipientsService(emailId: string) {
  return await http.get(`${API_BASE_AUDIENCE}get_publish_recipients/${emailId}`);
}

let cancelTokenActivateRecipients: any;
export async function activeInactiveListContactService(campaignId: string, updatedRecipientLists: any, updatedRecipientContacts: any) {
  //Check if there are any previous pending requests
  if (typeof cancelTokenActivateRecipients != typeof undefined) {
    cancelTokenActivateRecipients && cancelTokenActivateRecipients.cancel('Operation canceled due to new request.');
  }
  //Save the cancel token for the current request
  cancelTokenActivateRecipients = axios.CancelToken.source();
  const payload = new FormData();
  payload.append('campaign_id', campaignId);
  if (updatedRecipientLists.length > 0) payload.append('recipient_lists', JSON.stringify(updatedRecipientLists));
  if (updatedRecipientContacts.length > 0) payload.append('recipient_contacts', JSON.stringify(updatedRecipientContacts));
  return await http.post(
    `${API_BASE_AUDIENCE}active_inactive_list_contact/`,
    payload,
    { cancelToken: cancelTokenActivateRecipients.token }, //Pass the cancel token to the current request
  );
}

export async function getOrganizationsService(listId?: string, search?: string) {
  let url = `${API_BASE_AUDIENCE}get_all_organizations/`;
  if (listId) url += `?list_id=${listId}`;
  if (search) url += `&search_organisation=${search}`;
  return await http.get(url);
}

export async function getDesignationsService(listId?: string, search?: string) {
  let url = `${API_BASE_AUDIENCE}get_all_designations/`;
  if (listId) url += `?list_id=${listId}`;
  if (search) url += `&search_designation=${search}`;
  return await http.get(url);
}

export async function createNewListInWorkflowService(listName: string) {
  const payload = new FormData();
  payload.append('list_name', listName);
  return await http.post(`${API_BASE_AUDIENCE}create_list/`, payload);
}
